"use strict";
/*
 * Uniter Markdown Plugin - Adds support for an inline Markdown syntax to PHP
 * Copyright (c) Dan Phillimore (asmblah)
 * https://github.com/uniter/markdown-plugin/
 *
 * Released under the MIT license
 * https://github.com/uniter/markdown-plugin/raw/master/MIT-LICENSE.txt
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.factory = void 0;
var ListItemNode = /** @class */ (function () {
    function ListItemNode(internals, elements) {
        this.internals = internals;
        this.elements = elements;
    }
    ListItemNode.prototype.toHtml = function () {
        var _this = this;
        var valueHelper = this.internals.valueHelper;
        return this.internals.createFFIResult(function () {
            // For both sync and psync modes
            return ('<li>' +
                _this.elements
                    .map(function (element) {
                    return valueHelper.toNativeWithSyncApi(element);
                })
                    .map(function (element) { return element.toHtml(); })
                    .join('') +
                '</li>');
        }, function () {
            // Only for async mode
            return Promise.all(_this.elements.map(function (element) { return element.toHtml(); })).then(function (htmls) {
                return '<li>' + htmls.join('') + '</li>';
            });
        });
    };
    return ListItemNode;
}());
exports.default = ListItemNode;
var factory = function (internals) {
    return /** @class */ (function (_super) {
        __extends(ModeSpecificListItemNode, _super);
        function ModeSpecificListItemNode(elements) {
            return _super.call(this, internals, elements) || this;
        }
        return ModeSpecificListItemNode;
    }(ListItemNode));
};
exports.factory = factory;
//# sourceMappingURL=ListItemNode.js.map